<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <h1 langkey="voucherscan_enter_pin_text"></h1>
  </header>
  <sot-numberPad #numberPad [requiredLength]="requiredVoucherPinLength" [hideInput]="true"
    [isPIN]="true"></sot-numberPad>
  <footer class="buttons">
    <a class="btn goback insert" (click)="cancel()">
      <div inlineSVG="sot/sot-icon.svg#sot-close" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      <span langkey="button_cancel"></span>
    </a>
    <a [class.disabled]="submitDisabled" (click)="submit()" class="btn goforward">
      <span langkey="button_continue"></span>
      <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
    </a>
  </footer>
</div>